const ReportDuration = ({ children, forceWip }) => forceWip ? 'WIP' : (children ? children : 'WIP')

export default ReportDuration;